module.exports = __webpack_public_path__ + "static/media/jose.89fb1645.png";